export default "__VITE_ASSET__93805a82__"